const BASE = '/api';
const V1   = `${BASE}/v1`;

export const endpoints = {
  ping: `${BASE}/ping`,

  auth: {
    login:        `${V1}/auth/log-in`,
    logout:       `${V1}/auth/log-out`,
    signUp:       `${V1}/auth/sign-up`,
    verifyToken:  `${V1}/auth/verify-token`,
    refreshToken: `${V1}/auth/refresh-dfs-token`,
  },

  categories: {
    list:       `${V1}/document-validation-rules/`,
    byId:       (id: number) => `${V1}/document-validation-rules/${id}`,
    status:     (id: number) => `${V1}/document-validation-rules/status/${id}`,
    phrases:    (id: number) => `${V1}/document-validation-rules/phrases/${id}`,
    attributes: (id: number) => `${V1}/document-validation-rules/attributes/${id}`,
  },

  users: {
    list:       `${V1}/admin/users`,
    byId:       (id: number) => `${V1}/admin/users/${id}`,
    clearCache: `${V1}/admin/cache`,
  },

  logs: {
    byLevel: (level: string, lines: number, includeOlder: boolean) =>
      `${BASE}/logs/${level}?lines=${lines}&include_older=${includeOlder}`,
  },

  excelDiff: {
    compare: `${V1}/data-comparison/compare`,
    status: (tracking_tag: string) =>`${V1}/data-comparison/compare/status/${tracking_tag}`,
    results: (tracking_tag: string) =>`${V1}/data-comparison/compare/result/${tracking_tag}`,
  },

  customComparison: {
    meta:      `${V1}/data-comparison/custom-comparison`,        // GET  — list uploaded files
    compare:   `${V1}/data-comparison/custom-comparison`,        // POST — trigger comparison
    uploadAt:  (position: number) => `${V1}/data-comparison/custom-comparison/${position}`, // POST — upload file
  },

  pvr: {
    byCategory: (catNum: number) => `${V1}/data-comparison/pvr/${catNum}`,
  },

  healthCheck: {
    manufacturers: `${V1}/healthcheck/`,
    analyze:       `${V1}/healthcheck/analyze`,
    status:        (name: string) => `${V1}/healthcheck/status/${name}`,
    results:       (name: string) => `${V1}/healthcheck/prev_res/${name}`,
    export:        (name: string) => `${V1}/healthcheck/prev_res/${name}/export`,
    uploadCsv:     (name: string) => `${V1}/healthcheck/upload_csv/${name}`,
    generalExport: (name: string) => `${V1}/healthcheck/upload_csv/${name}/export`,
  },
} as const;
